<div class="col calendar-day-container d-flex align-items-center justify-content-center"
  [class]="dayType | eDayTypeToStringPipe" [class.c-pointer]="isDisabled != true" [class.disabled]="isDisabled == true"
  [class.selected]="isSelected == true" (click)="onClick()">
  <span>{{day?.getDate()}}</span>
  @if (dayType == eDayType.Holiday) {
    <span class="holiday-info" i18n="@@CalendarDayHolidayInfo">Holiday</span>
  }
</div>